export const getKayakAssetsURL = path => process.env.REACT_APP_KAYAK_ASSETS_URL.concat(path);
